import { toast } from "sonner";
import { API_ENDPOINTS, HTTP_METHODS } from "../config/api";
import { BaseApiService, ApiResponse } from "./baseApi";

// Production Summary Report DTO
export interface ProductionSummaryReportDto {
  workerName?: string;
  physicalMachineName?: string;
  productionDate?: string;
  workOrderId?: number;
  workOrderNumber?: string;
  grnId?: number | null;
  grnNumber?: string | null;
  heatNo?: string | null;
  endgoodName?: string;
  processName?: string;
  workArea?: string;
  productionQty?: number;
  rejectQty?: number;
}

// Worker Daily Performance (matches backend WorkerDailyPerformanceDto)
export interface WorkerDailyPerformanceDto {
  workerName?: string;
  performanceDate?: string;
  endgoodName?: string;
  processName?: string;
  quantity?: number;
}

// Production Report API Service
class ProductionReportApiService extends BaseApiService {
  
  // Get production summary by branch and date range
  async getProductionSummaryByDateRange(
    branchId: number, 
    startDate: string, 
    endDate: string,
    searchText?: string
  ): Promise<ApiResponse<ProductionSummaryReportDto[]>> {
    try {
      const data = await this.makeRequest<ProductionSummaryReportDto[]>(
        API_ENDPOINTS.PRODUCTION_REPORTS.SUMMARY_BY_DATE_RANGE(branchId, startDate, endDate, searchText),
        { method: HTTP_METHODS.GET }
      );
      
      return {
        success: true,
        message: 'Production summary report fetched successfully',
        data: Array.isArray(data) ? data : []
      };
    } catch (error) {
      // console.error('ProductionReportApiService: Error fetching production summary:', error);
      toast.error('Failed to fetch production summary report');
      throw error;
    }
  }

  /** GET /reports/worker-daily-performance with optional workerId, branchId, startDate, endDate */
  async getWorkerDailyPerformance(
    params: { branchId?: number; workerId?: number; startDate?: string; endDate?: string }
  ): Promise<ApiResponse<WorkerDailyPerformanceDto[]>> {
    try {
      const data = await this.makeRequest<WorkerDailyPerformanceDto[]>(
        API_ENDPOINTS.WORKER_DAILY_PERFORMANCE(params),
        { method: HTTP_METHODS.GET }
      );
      return {
        success: true,
        message: 'Worker daily performance fetched successfully',
        data: Array.isArray(data) ? data : [],
      };
    } catch (error) {
      toast.error('Failed to fetch worker daily performance');
      throw error;
    }
  }
}

export const productionReportApiService = new ProductionReportApiService();

